import GbpoGlobalPlugin from './plugins/GbpoGlobalPlugin'

export const Plugins = [
  GbpoGlobalPlugin
]



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/plugins.js